import { inject, injectable } from 'inversify'
import { SERVICE_TYPES } from '@/core/container/types'
import type { Resolvable } from '@/services/resolvers/types'
import type UserNumbersPreloaderService from '@/services/preloaders/userNumbersPreloaderService'
import type { IMainServerSub } from '@/services/transport/serverEvents'

@injectable()
export default class UserNumbersResolverService implements Resolvable {
  constructor(
    @inject(SERVICE_TYPES.UserNumbersPreloaderService)
    protected readonly userNumbersPreloaderService: UserNumbersPreloaderService,
    @inject(SERVICE_TYPES.ServerSubscriptionService) protected serverSubscriptionService: IMainServerSub,
  ) {}

  protected onSystemAccountNumbersListChange = this.onSystemAccountNumbersListChangeCallback.bind(this)

  public isPersistent = () => true

  public getResolverKeys = () => ['userNumbersResolverService']

  public async resolve() {
    await this.userNumbersPreloaderService.preload()

    this.serverSubscriptionService.subscribe('systemAccountNumbersListChange', this.onSystemAccountNumbersListChange)
  }

  public async unresolve() {
    this.serverSubscriptionService.unsubscribe('systemAccountNumbersListChange', this.onSystemAccountNumbersListChange)
  }

  protected onSystemAccountNumbersListChangeCallback() {
    this.userNumbersPreloaderService.markAsNotPreloaded()
  }
}
